import script from "./InventoryTemplatePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryTemplatePage.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryTemplatePage.vue?vue&type=style&index=0&id=7b0d6a59&scoped=true&lang=scss"
import "./InventoryTemplatePage.vue?vue&type=style&index=1&id=7b0d6a59&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0d6a59"]])

export default __exports__